import {
  applySpec,
  debounce,
  flow,
  get,
  identity,
  log,
  map,
  merge,
  pick,
  pipe,
  tap,
} from '@yandex-delivery/utils'
import {fetchPersistDraftSync, fetchRestoreDraftSync} from 'src/shared/api'
import type {Order as FormValues} from 'src/shared/types'

const getSourcePoint = pick(['address', 'contact', 'dropOffPoint'])
const getDestinationPoint = pick([
  'address',
  'contact',
  'parcels',
  'pickUpPoint',
  '_type',
])

/**
 * функция сохранения стейта формы с в каком-то хранилище (в текущий момент времени это localStorage)
 * в данные момент она синхронна, но в целом ничего не мешает сделать ее асинхронной.
 * но тогда нужно изменить подход в UI, например, показать модалку "восстановить данные? да/нет"
 */
export const persistFormValues: (formValues: FormValues) => FormValues =
  // debounce рядом с flow читается лучше
  debounce(
    flow(
      // tap(log('%c VALUES', 'color: #4CAF50; font-weight: bold')),
      applySpec({
        isBusiness: get('isBusiness'),
        deliveryType: get('deliveryType'),
        ndd: get('ndd'),
        sourcePoint: flow(get('sourcePoint'), getSourcePoint),
        destinationPoints: flow(
          get('destinationPoints'),
          map(getDestinationPoint),
        ),
        _preOrderId: get('_preOrderId'),
        offerFlow: applySpec({
          deliveryDirection: get('offerFlow.deliveryDirection'),
          vertical: {
            name: get('offerFlow.vertical.name'),
            // fixme: временно закомментируем сохранение требований,
            //        потому что компонент для работы с ними написан криво
            //        и не умеет нормально работать с восстановленным стейтом
            // requirements: flow(
            //   get('offerFlow.vertical.requirements'),
            //   // будем сохранять только не пустые требования
            //   pickBy(function byFilledSelectedValue(value: VerticalRequirement) {
            //     if (value.selectedValue !== undefined) {
            //       if (Array.isArray(value.selectedValue)) {
            //         return value.selectedValue.length > 0
            //       }
            //
            //       return true
            //     }
            //   }),
            //   mapEntries(function (key, value: VerticalRequirement) {
            //     return [key, {selectedValue: value.selectedValue}]
            //   }),
            // ),
          },
        }),
      }),
      // tap(log('%c DRAFT', 'color: #4CAF50; font-weight: bold')),
      fetchPersistDraftSync,
    ),
    500,
    // не охота было возиться с типами debounce, поэтому решил за кастить
  ) as unknown as (formValues: FormValues) => FormValues

/**
 * функция восстановления стейта формы из черновика
 */
export const restoreFormValues: (formValues: FormValues) => FormValues = pipe(
  //
  fetchRestoreDraftSync<FormValues>(),
  function _restoreFormValues(formValues?: FormValues) {
    if (
      formValues &&
      // хитрый ход, чтобы стирать драфты из атису, делается для того, чтобы габариты закостыленные в https://st.yandex-team.ru/CARGODEV-47051, после захода на ордер без pre_order_id стирались
      !formValues._preOrderId
    ) {
      // возвращаем функцию для модификации стейта (flow тут только для логгирования)
      return flow(
        tap(() => {
          log('Черновик')(formValues)
        }),
        (values: FormValues) => merge(values, formValues),
        tap(log('Стейт после черновика')),
      )
    }

    return identity
  },
)
